import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { reportError } from 'automation-ui-core/errors/utils/reportError';
import ErrorMessage from 'automation-ui-canvas/components/errors/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const DynamicImportError = (Wrapper = ErrorMessage) => ({
  error,
  retry
}) => {
  reportError({
    error
  });
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary-light",
      onClick: retry,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "fatalErrors.errors.retryButton"
      })
    })
  });
};
export default DynamicImportError;